import type { CompanyType, CompanyWithCategoriesType } from "@/types/company";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchCompanies = async (includeCategories: boolean = false) => {
  const response = await axios.get(
    "https://kaman.rest/api/companies?include_categories=" + includeCategories
  );
  return response.data.data.companies.map((company: any) => {
    let workingHours = JSON.parse(company.settings.working_hours || "{}");

    workingHours = Object.values(workingHours).map((slot: any) => [
      slot.from ? parseInt(slot.from.replace(":", ""), 10) : null,
      slot.to ? parseInt(slot.to.replace(":", ""), 10) : null,
    ]);

    return {
      id: company.id,
      name: company.name,
      address: company.settings.address,
      workingHours: workingHours,
      image: company.settings.logo,
    };
  });
};

export function useCompanies(
  includeCategories: true
): ReturnType<typeof useQuery<CompanyWithCategoriesType[]>>;

export function useCompanies(
  includeCategories?: false
): ReturnType<typeof useQuery<CompanyType[]>>;

export function useCompanies(includeCategories: boolean = false) {
  return useQuery({
    queryKey: ["companies", includeCategories],
    queryFn: () => fetchCompanies(includeCategories),
  });
}
